import { render, staticRenderFns } from "./Outpost.vue?vue&type=template&id=a23f04ce&"
import script from "./Outpost.vue?vue&type=script&lang=js&"
export * from "./Outpost.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports